import { ArrowRight } from 'iconsax-react';
import React from 'react';

interface Props {
  title: string;
  onClick: () => void;
}

const ButtonAnimation = ({ title, onClick }: Props) => {
  return (
    <div className="button-animation" onClick={onClick}>
      <span>{title}</span>
      <ArrowRight size="24" color="#5A6178" />
    </div>
  );
};

export default React.memo(ButtonAnimation);
